import {
    CENTRA_LOCALE_SHIPPING_COUNTRY_CODES,
    CentraLocaleShippingCountryCode
} from "../data/centra-locale-shipping-country-code"
import { SHIPPING_COUNTRIES, ShippingCountry } from "../data/shipping-countries"
import {
    SHIPPING_COUNTRY_CODES,
    ShippingCountryCode
} from "../data/shipping-country-code"

export type ShippingCountryCodeToNameMap = Map<ShippingCountryCode, ShippingCountry>

const shippingCountryCodeToShippingCountryName: ShippingCountryCodeToNameMap = new Map<
    ShippingCountryCode,
    ShippingCountry
>([
    [SHIPPING_COUNTRY_CODES.Austria, SHIPPING_COUNTRIES.Austria],
    [SHIPPING_COUNTRY_CODES.Belgium, SHIPPING_COUNTRIES.Belgium],
    [SHIPPING_COUNTRY_CODES.Bulgaria, SHIPPING_COUNTRIES.Bulgaria],
    [SHIPPING_COUNTRY_CODES.Croatia, SHIPPING_COUNTRIES.Croatia],
    [SHIPPING_COUNTRY_CODES.Cyprus, SHIPPING_COUNTRIES.Cyprus],
    [SHIPPING_COUNTRY_CODES.CzechRepublic, SHIPPING_COUNTRIES.CzechRepublic],
    [SHIPPING_COUNTRY_CODES.Denmark, SHIPPING_COUNTRIES.Denmark],
    [SHIPPING_COUNTRY_CODES.Estonia, SHIPPING_COUNTRIES.Estonia],
    [SHIPPING_COUNTRY_CODES.Finland, SHIPPING_COUNTRIES.Finland],
    [SHIPPING_COUNTRY_CODES.France, SHIPPING_COUNTRIES.France],
    [SHIPPING_COUNTRY_CODES.Germany, SHIPPING_COUNTRIES.Germany],
    [SHIPPING_COUNTRY_CODES.Greece, SHIPPING_COUNTRIES.Greece],
    [SHIPPING_COUNTRY_CODES.Hungary, SHIPPING_COUNTRIES.Hungary],
    [SHIPPING_COUNTRY_CODES.Ireland, SHIPPING_COUNTRIES.Ireland],
    [SHIPPING_COUNTRY_CODES.Italy, SHIPPING_COUNTRIES.Italy],
    [SHIPPING_COUNTRY_CODES.Latvia, SHIPPING_COUNTRIES.Latvia],
    [SHIPPING_COUNTRY_CODES.Lithuania, SHIPPING_COUNTRIES.Lithuania],
    [SHIPPING_COUNTRY_CODES.Luxembourg, SHIPPING_COUNTRIES.Luxembourg],
    [SHIPPING_COUNTRY_CODES.Malta, SHIPPING_COUNTRIES.Malta],
    [SHIPPING_COUNTRY_CODES.Netherlands, SHIPPING_COUNTRIES.Netherlands],
    [SHIPPING_COUNTRY_CODES.NewZealand, SHIPPING_COUNTRIES.NewZealand],
    [SHIPPING_COUNTRY_CODES.Norway, SHIPPING_COUNTRIES.Norway],
    [SHIPPING_COUNTRY_CODES.Poland, SHIPPING_COUNTRIES.Poland],
    [SHIPPING_COUNTRY_CODES.Portugal, SHIPPING_COUNTRIES.Portugal],
    [SHIPPING_COUNTRY_CODES.Romania, SHIPPING_COUNTRIES.Romania],
    [SHIPPING_COUNTRY_CODES.Slovakia, SHIPPING_COUNTRIES.Slovakia],
    [SHIPPING_COUNTRY_CODES.Slovenia, SHIPPING_COUNTRIES.Slovenia],
    [SHIPPING_COUNTRY_CODES.Spain, SHIPPING_COUNTRIES.Spain],
    [SHIPPING_COUNTRY_CODES.Sweden, SHIPPING_COUNTRIES.Sweden],
    [SHIPPING_COUNTRY_CODES.Switzerland, SHIPPING_COUNTRIES.Switzerland],
    [SHIPPING_COUNTRY_CODES.UnitedKingdom, SHIPPING_COUNTRIES.UnitedKingdom],
    [SHIPPING_COUNTRY_CODES.Canada, SHIPPING_COUNTRIES.Canada],
    [SHIPPING_COUNTRY_CODES.USA, SHIPPING_COUNTRIES.USA],
    [SHIPPING_COUNTRY_CODES.Australia, SHIPPING_COUNTRIES.Australia],
    [SHIPPING_COUNTRY_CODES.Japan, SHIPPING_COUNTRIES.Japan]
])

export const getShippingCountryNameByShippingCountryCode = (
    shippingCountryCode: ShippingCountryCode
): ShippingCountry | undefined =>
    shippingCountryCodeToShippingCountryName.get(shippingCountryCode)

export const getShippingCountryNameByCentraLocaleShippingCountryCode = (
    centraLocaleShippingCountryCode: CentraLocaleShippingCountryCode,
    getShippingCountryCodeByCentraLocaleShippingCountryCode: (
        centraLocaleShippingCountryCode: CentraLocaleShippingCountryCode,
        centraLocaleShippingCountryCodes: typeof CENTRA_LOCALE_SHIPPING_COUNTRY_CODES
    ) => ShippingCountryCode | undefined
): ShippingCountry | undefined => {
    const shippingCountryCode = getShippingCountryCodeByCentraLocaleShippingCountryCode(
        centraLocaleShippingCountryCode,
        CENTRA_LOCALE_SHIPPING_COUNTRY_CODES
    )

    return shippingCountryCode
        ? shippingCountryCodeToShippingCountryName.get(
              shippingCountryCode.toUpperCase() as ShippingCountryCode
          )
        : undefined
}
